import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { beforeItems, afterItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-62" data-mp="3ofhxvfzy3nzu">
      <div className="mx-auto max-w-5xl" data-id="element-63" data-mp="3sgl9trevgzvs">
        <SectionHeading eyebrow="The transformation" title={<>Before vs. <em className="text-gold-dark" data-id="element-65" data-mp="3eox01us3inhz">after</em> the Playbook</>} data-id="element-64" data-mp="3sfjq6yjsj52g" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-66" data-mp="3jgeqvq0en7p8">
          <div className="rounded-3xl bg-white p-6 sm:p-8 ring-2 ring-danger/20" data-id="element-67" data-mp="3jhzltgqmssnm">
            <div className="flex items-center gap-3" data-id="element-68" data-mp="34t3i1vvly1st">
              <span className="rounded-full bg-danger px-4 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-69" data-mp="39qlp1gq2e6y6">Before</span>
              <span className="text-sm font-semibold text-ink/50" data-id="element-70" data-mp="2vsf04q33fhan">Scattered & in your head</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-71" data-mp="30pnlezjjg1g4">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-72" data-mp="x38x8sr5occ0">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger/10" data-id="element-73" data-mp="t38l5erj4d84">
                    <XIcon className="h-4 w-4 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-74" data-mp="172zx79yhjjjh" />
                  </span>
                  <span className="text-[17px] leading-snug text-ink/70" data-id="element-75" data-mp="124yc6jhi1a5d">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-ink p-6 sm:p-8 ring-2 ring-gold" data-id="element-76" data-mp="9f9a02t1z426">
            <div className="flex items-center gap-3" data-id="element-77" data-mp="9cwlt7wpbxgo">
              <span className="rounded-full bg-gold px-4 py-1.5 text-sm font-black uppercase tracking-wider text-ink" data-id="element-78" data-mp="o4xax2xbo0pd">After</span>
              <span className="text-sm font-semibold text-white/60" data-id="element-79" data-mp="jbuhcusjor96">Documented & repeatable</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-80" data-mp="3rqm962cxthq1">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-81" data-mp="3mrrsp72g0593">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-82" data-mp="1qrix9a7me3kv">
                    <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-83" data-mp="1voj5nrrxzif5" />
                  </span>
                  <span className="text-[17px] font-medium leading-snug text-white" data-id="element-84" data-mp="20hc8ub7riip4">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="Yes, take me to the “after”" data-id="element-85" data-mp="17t6npncsqror" />
      </div>
    </section>;
}